export class PatientEmailNotEqualsToInMvError extends Error {
  constructor() {
    super(
      'Você já possui um cadastro na rede Mater Dei. Envie um e-mail de contato para a área de gestão de leitos do hospital: gestaodeleitos@materdei.com.br'
    )
    this.name = 'PatientEmailNotEqualsToInMvError'
  }
}
